/**
 * Contact: the headline is the route's own line; faqEyebrow, faqSub and the form copy are the plate
 * and the form beside it. Change the words here, never in the components.
 */
export const contactPage = {
  eyebrow: 'Contact',
  titleThin: 'Tell me what',
  titleBold: 'you need automated.',
  lede: 'Read the answers first. If your question is still open, write below — or call +63 994 374 7657. I reply within one business day.',
  faqEyebrow: 'FAQs',
  faqTitle: 'Quick answers',
  faqSub: 'Still have one? Write below.',
  cardTitle: 'Send me a message',
  cardBody: 'What do you need? What are you using today? Two or three lines is enough.',
}

/** The form. Send delivers the message straight to the site owner. */
export const contactForm = {
  first: 'First name',
  last: 'Last name',
  email: 'Email',
  message: 'Tell me more about your project',
  phFirst: 'First name',
  phLast: 'Last name',
  phEmail: 'you@yourbusiness.com',
  phMessage: 'What do you need? What are you using today? What does a good result look like?',
  send: 'Send message',
  sending: 'Sending…',
  hint: 'Your message comes straight to me. I reply within one business day.',
  error: 'Add your name, a real email, and a short note.',
  failed: 'Something went wrong sending your message. Please try again, or email me directly.',
  rateLimited: 'You have sent a few messages already. Please wait a few minutes and try again.',
  sentTitle: 'Message sent. Thank you!',
  sentBody: 'I got your message and will reply to your email within one business day.',
  // Shown under the sent state, for anyone who wants to write directly too.
  noMailApp: 'Prefer email? Write to',
  copy: 'Copy message',
  copied: 'Copied',
  again: 'Write another',
}
